/* eslint-disable react/no-unused-prop-types */

import React from 'react';
import {
  Card,
  CardMedia,
  CardTitle,
  ThemeProvider
} from '@one-thd/sui-atomic-components';
import proptypes from 'prop-types';
import { useImpression } from '@thd-olt-component-react/impression';
import classNames from 'classnames';
import { akamaiImageResize } from './helper';
import * as styles from './visual-navigation.scss';

const { bool, number, shape, string } = proptypes;
export const VisualNavigationCard = ({
  item = {},
  position = 1,
  lazyLoad = false,
  theme = '',
  enableB2CRadius = false,
  enableFullBleed = false
}) => {
  let {
    altText,
    id: itemID,
    link,
    title,
    previewImage,
    // sys (only needed for live preview/contentful)
    sys: { id: livePreviewID } = { id: '' }
  } = item;

  const { ref, clickID } = useImpression({
    data: {
      id: itemID || livePreviewID,
      component: 'VisualNavigation',
      name: 'VisualNavigation',
      type: 'content',
      position
    }
  });

  let damDownloadedContentImage = previewImage?.damDownloadedContent;
  let damContentSelectorImage = previewImage?.damContentSelector?.assetData?.[0];
  let imageUrl = damDownloadedContentImage?.url || damContentSelectorImage?.selectedImageUrl;

  imageUrl = akamaiImageResize(imageUrl, 703);

  const cardMediaClasses = classNames(
    { '!sui-rounded-[12px]': enableB2CRadius },
  );

  const cardClasses = classNames(
    'sui-w-full link--hover-no-underline hover:sui-shadow-lg',
    { '!sui-rounded-[12px]': enableB2CRadius }
  );

  const cardContainerClass = classNames(
    { 'sui-align-middle': !imageUrl },
    'sui-flex sui-h-full sui-w-full',
  );

  const paperProps = enableFullBleed ? { variant: 'shadow', shadow: 'none' } : {};
  const cardTitleClass = classNames({ 'sui-px-4 sui-pb-4': enableFullBleed });

  return (
    <ThemeProvider theme={theme}>
      <div
        ref={ref}
        /* eslint-disable-next-line react/no-unknown-property */
        clickid={clickID}
        key={`card-position-${position}`}
        className={cardContainerClass}
        data-component="VisualNavigationCard"
        data-contentful-entry-id={livePreviewID}
        data-contentful-field-id="internalName"
      >
        <Card
          key={itemID}
          href={link}
          target="_blank"
          rel="noreferrer"
          className={cardClasses}
          disablePadding={enableFullBleed}
          PaperProps={paperProps}
        >
          {imageUrl && (
            <CardMedia
              alt={`${altText || title}`}
              title={`${altText || title}`}
              src={imageUrl}
              aspect="square"
              loading={lazyLoad ? 'lazy' : ''}
              data-contentful-entry-id={livePreviewID}
              data-contentful-field-id="previewImage"
              className={cardMediaClasses}
            />
          )}
          {title && (
            <div className={cardTitleClass}>
              <CardTitle
                actionPosition="center"
                headerWeight="bold"
                header={title}
                headerVariant="h5"
                data-contentful-entry-id={livePreviewID}
                data-contentful-field-id="title"
              />
            </div>
          )}
        </Card>
      </div>
    </ThemeProvider>
  );
};

const displayName = 'VisualNavigationCard';

const propTypes = {
  item: shape({}),
  position: number,
  lazyLoad: bool,
  theme: string,
  enableB2CRadius: bool,
  enableFullBleed: bool
};

VisualNavigationCard.displayName = displayName;
VisualNavigationCard.propTypes = propTypes;
